/**
 * CommissionSection Component - Shopify Sales Channel Requirement
 *
 * Displays commission and fee information using Polaris Card
 * and Layout.AnnotatedSection as required by Shopify.
 *
 * Must clearly state:
 * - Commission rate
 * - How merchants are charged
 * - When merchants are charged
 */

import React from 'react';
import {
  Layout,
  Card,
  Text,
  BlockStack,
  Box,
  List
} from '@shopify/polaris';

export default function CommissionSection() {
  return (
    <Layout.AnnotatedSection
      title="Commission & Fees"
      description="Information about fees for using InClub as a sales channel."
    >
      <Card>
        <BlockStack gap="4">
          <Box>
            <Text variant="headingMd" as="h3">No Commission Fees</Text>
          </Box>

          <Text variant="bodyMd">
            InClub does not charge any commission on sales made through the InClub sales channel.
          </Text>

          <Text variant="bodyMd" tone="subdued">
            InClub subscription fees (if applicable) are billed separately through Shopify App billing.
          </Text>
        </BlockStack>
      </Card>
    </Layout.AnnotatedSection>
  );
}
